import { profanity } from '@2toad/profanity';
import { PublicKey } from '@solana/web3.js';
import Decimal from "decimal.js";

// https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

export const isNumeric = (value) => {
    return /^-?\d+$/.test(value);
}

export const validEmail = (value) => {
    return (
        EMAIL_REGEX.test(value) ||
        "It should be a valid email address."
    );
};

export const required = (value) => {
    return (value && value?.length && value?.trim() !== "") || "Required..";
};

export const requiredNumber = (value) => {
    return (value !== null && value !== undefined) || "Required..";
};

export const dateIsRequired = (value) => {
    return (value !== null && value !== undefined) || "Required..";
};

export const minLength = (value, len) => {
    return value?.length >= len || `Minimum of ${len} characters.`;
};

export const maxLength = (value, len) => {
    return value?.length <= len || `${len} characters max.`;
};

export const leastOneUppercase = (value) => {
    return /[A-Z]/.test(value) || "At least 1 uppercase character.";
};

export const leastOneLowercase = (value) => {
    return /[a-z]/.test(value) || "At least 1 lowercase character.";
};

export const leastOneNumber = (value) => {
    return /[0-9]/.test(value) || "At least 1 number.";
};

export const onlyNumbers = (value) => {
  return isNumeric(value) || "Only numbers are allowed.";
};

export const onlyNumbersWithDecimals = (value) => {
    return /^\d*(\.\d*)?$/.test(value) || "Only numbers are allowed.";
};

export const isValidDecimal = (number) => {
    const decimalRegex = /^[-+]?\d+\.\d+$/;
    return decimalRegex.test(number);
};

export const minVal = (value, min) => {
    return Number(value) >= Number(min) || `Minimum ${min}.`;
};

export const maxVal = (value, max) => {
    return Number(value) <= Number(max) || `Maximum ${max}.`;
};

export const leastOneSpecialCharacter = (value) => {
    return /[!@#$%^&*]/.test(value) || "At least 1 special symbol.";
};

export const validPassword = (value) => {
    return (
        leastOneUppercase(value) &&
        leastOneLowercase(value) &&
        leastOneNumber(value)
    );
};

export const validName = (value) => {
    return (
        /^[a-zA-Z0-9]+$/.test(value) ||
        "We only accept letters and numbers in this field."
    );
};

export const withoutSpaces = (value) => {
    return (
        !/\s/.test(value) ||
        "This field does not accept spaces."
    );
};

export const isAllTrue = (array) => {
    if (!array) return false;
    return array.every((value) => value === true);
};

export const notBadWords = (value) => {
    return (
        !profanity.exists(value) ||
        "This display name does not conform to our guidelines, please enter a different display name."
    );
};

export const isEthereumAddressBoolean = (value) => {
    return /^(0x)?[0-9a-f]{40}$/i.test(value)
}

export const isSolanaAddressBoolean = (value) => {
    let isValid = false
    try {
        const address = new PublicKey(value)
        isValid = PublicKey.isOnCurve(address)
    } catch (e) {}
    return isValid
}

export const isEthereumAddress = (value) => {
    return (
        isEthereumAddressBoolean(value) ||
        "It should be a valid Ethereum address."
    );
}

export const isSolanaAddress = (value) => {
    return (
        isSolanaAddressBoolean(value) ||
        "It should be a valid Solana address."
    );
}

export const isUrlAddress = (value) => {
  return (
    /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(value) ||
    "It should be a valid url address."
  );
}


export const validateGreaterOrEqualThan = (num1, num2, msg) => {
  if (Decimal(num1).greaterThanOrEqualTo(num2)) {
    return true;
  } else {
    return msg;
  }
}

export const validateLessOrEqualThan = (num1, num2, msg) => {
    if (Decimal(num1).lessThanOrEqualTo(num2)) {
      return true;
    } else {
      return msg;
    }
  }
